<template>
  <div>
    <div class="topDiv">
      <span>是否打印所有内容？</span>
      <el-button @click="goBack">返 回</el-button>
      <el-button type="primary" v-print="printObj">打 印</el-button>
    </div>
      <div class="printContract">
        <div class="contentPrint" id="printContract">
          <div class="title">待租房屋明细</div>
          <el-table
              v-loading="loading"
              :data="tableData"
              :default-sort = "{prop: 'id', order: 'descending'}"
              style="width: 100%"
              :highlight-current-row="false">
            <el-table-column
                label="序号"
                type="index"
                width="50">
            </el-table-column>
            <template v-for="(item, index) in tableColumns">
              <el-table-column
                  :key="index"
                  :prop="item.prop"
                  :label="item.label"
                  :width="item.width">
              </el-table-column>
            </template>
          </el-table>
      </div>
      </div>
  </div>
</template>

<script>
import { queryExcelAvailableBuilding } from '@/api/statistics'

export default {
  name: 'printForRent',
  data () {
    return {
      loading: false,
      printObj: {
        id: 'printContract',
        popTitle: '打印',
        extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>'
      },
      companyId: this.$route.query.companyId,
      buildingId: this.$route.query.buildingId,
      tableData: [],
      tableColumns: [
        {
          prop: 'companyName',
          label: '公司名称',
          width: 150
        },
        {
          prop: 'buildingName',
          label: '楼宇名称',
          width: 120
        },
        {
          prop: 'buildingAddr',
          label: '地址',
          width: 120
        },
        {
          prop: 'rentAbleArea',
          label: '待租面积(㎡)',
          width: 120
        },
        {
          prop: 'rentFee',
          label: '日租金',
          width: 120
        },
        {
          prop: 'manageFeeUnit',
          label: '物业费',
          width: 100
        },
        {
          prop: 'remark',
          label: '备  注',
          width: 150
        }
      ]
    }
  },
  components: {},
  mounted () {
    this.queryList()
  },
  methods: {
    // 查询
    async queryList () {
      let res = await queryExcelAvailableBuilding({
        companyId: this.companyId,
        buildingId: this.buildingId
      })
      if (res.code === 0) {
        this.tableData = res.result ? res.result.records : []
        // res.result.records.forEach(item => {
        //   this.tableData.push({
        //     companyName: item.companyName,
        //     buildingName: item.buildingName,
        //     buildingAddr: item.buildingAddr,
        //     differenceRentableArea: item.differenceRentableArea,
        //     dailyRental: item.minDailyRental + '元-' + item.maxDailyRental + '元',
        //     manageFeeUnit: item.manageFeeUnit,
        //     remark: item.remark
        //   })
        // })
      }
    },
    // 取消
    goBack () {
      this.$router.push('/report/forRent')
    }
  }
}
</script>

<style lang="scss" scoped>
  .topDiv{
    padding-left: .6rem;
    width: 10rem;
    margin: .25rem auto;
    font-size: .16rem;
    letter-spacing: .03rem;
  }
  .printContract{
    margin: 0 auto;
    width: 56%;
    /*background-color: #fff;*/
    .contentPrint{
      width: 100%;
      .title{
        letter-spacing: .03rem;
        font-size: .16rem;
        margin-bottom: .1rem;
        margin-top: .2rem;
      }
    }
  }

  /deep/.el-table td{
    text-align:center !important
  }

</style>
